export const SERVER_COLOR_PALETTE = [
  '#EF4444', '#F97316', '#F59E0B', '#84CC16', '#22C55E', '#14B8A6',
  '#06B6D4', '#3B82F6', '#6366F1', '#8B5CF6', '#EC4899', '#F43F5E'
] as const;

type ServerColorVariant = 'dot' | 'swatch' | 'tone';

function hashString(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = ((hash << 5) - hash + input.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function getDefaultServerColor(serverId: string): string {
  const key = (serverId || '').trim();
  if (!key) return '#9CA3AF';
  return SERVER_COLOR_PALETTE[hashString(key) % SERVER_COLOR_PALETTE.length]!;
}

export function normalizeServerColor(color?: string | null): string | null {
  const normalized = (color || '').trim().toUpperCase();
  if (!normalized) return null;
  return SERVER_COLOR_PALETTE.includes(normalized as (typeof SERVER_COLOR_PALETTE)[number])
    ? normalized
    : null;
}

export function resolveServerColor(serverId: string, customColor?: string | null): string {
  return normalizeServerColor(customColor) || getDefaultServerColor(serverId);
}

function resolveServerColorIndex(serverId: string, customColor?: string | null): number {
  const normalized = normalizeServerColor(customColor);
  if (normalized) return SERVER_COLOR_PALETTE.indexOf(normalized as (typeof SERVER_COLOR_PALETTE)[number]);

  const key = (serverId || '').trim();
  if (!key) return -1;
  return hashString(key) % SERVER_COLOR_PALETTE.length;
}

export function resolveServerColorClass(
  serverId: string,
  customColor?: string | null,
  variant: ServerColorVariant = 'dot'
): string {
  const index = resolveServerColorIndex(serverId, customColor);
  const suffix = index >= 0 ? String(index) : 'neutral';
  return `server-color-${variant}-${suffix}`;
}
